import useSWR from "swr";

export const useFetchLatestReservationNumPeople = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `ifrea_analytics/restaurants/${restaurantId}/reservation-num-people/latest/` : null;
  const { data: reservationNumPeople, isLoading } = useSWR<number>(fetcherKey)
  return { reservationNumPeople, isLoading };
};